module.exports = __webpack_public_path__ + "static/get-your-app-ef256580e25e6a8e02331ce5badee5fd.png";